import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import React from 'react'
import styled, { css } from 'styled-components'
import { HealthAsk } from '../../models/health-ask'
import breakpoints from '../../styles/breakpoints'
import HealthIcon from './health-icon'

const AskSection = styled.section`
  display: grid;
  grid-template-areas:
    'icon title'
    'description description';
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  align-items: center;
  column-gap: ${props => props.theme.spacing.base400};

  @media (min-width: ${breakpoints.sm}) {
    grid-template-areas:
      'icon title'
      'icon description';
    grid-template-rows: auto;

    ${({ justification }: { justification: 'left' | 'right' }) =>
      justification === 'right' &&
      css`
        grid-template-areas:
          'title icon'
          'description description';
        grid-template-columns: 1fr auto;
        justify-items: end;
        text-align: right;

        @media (min-width: ${breakpoints.sm}) {
          grid-template-areas:
            'title icon'
            'description icon';
        }
      `}
  }
`

const Title = styled.h3`
  grid-area: title;

  @media (min-width: ${breakpoints.sm}) {
    align-self: end;
    margin-bottom: ${props => props.theme.spacing.base200};
  }
`

const Description = styled.span`
  grid-area: description;

  @media (min-width: ${breakpoints.sm}) {
    align-self: start;
    margin-top: ${props => props.theme.spacing.base200};
  }
`

const AskIcon = styled(HealthIcon)`
  grid-area: icon;
  width: 81px;
  height: 81px;

  @media (min-width: ${breakpoints.sm}) {
    width: 162px;
    height: 162px;
  }
`

const Ask = ({
  ask,
  justification = 'left',
  ...props
}: {
  ask: HealthAsk
  justification: 'left' | 'right'
}) => {
  return (
    <AskSection justification={justification} {...props}>
      <AskIcon type={ask.icon} />
      <Title>{ask.title}</Title>
      <Description>{documentToReactComponents(ask.message)}</Description>
    </AskSection>
  )
}

export default Ask
